const DEMO_PATH = "/book-a-demo";

// In-memory navigation trail for the current page load. Resets on a full reload,
// so it never reports a stale origin from an earlier visit in the same session.
let currentPath: string | null = null;
let previousPath: string | null = null;

/**
 * Records each client-side route change so we always know the page a visitor
 * came from. Called on every location change from App.tsx.
 */
export function recordNavigation(path: string) {
  if (path === currentPath) return;
  previousPath = currentPath;
  currentPath = path;
}

/**
 * Returns the page the visitor was on immediately before the demo form.
 * Uses the in-memory previous route first; falls back to the external referrer,
 * then "direct". Never reports the demo page itself.
 */
export function getDemoSource(): string {
  if (previousPath && !previousPath.startsWith(DEMO_PATH)) {
    return previousPath;
  }
  if (typeof document !== "undefined") {
    const ref = document.referrer;
    if (ref && !ref.includes(DEMO_PATH)) return ref;
  }
  return "direct";
}
